module.exports = "<p>לחצו בעמוד הבית על &quot;הירשם&quot;, מלאו את כתובת המייל שלכם והסיסמא בה תרצו להשתמש, אשרו את תנאיי השימוש והפרטיות ולחצו &quot;צור חשבון&quot;. אותם פרטים ישמשו אתכם גם כשתחזרו לאתר ותתחברו מחדש.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/1.md
// module id = 799
// module chunks = 0